export default "__VITE_ASSET__BzotwMST__"